import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Browser from '../../../../assets/Pdf/Browser(2025) .pdf';

import {
  Users,
  Calendar,
  Database,
  BookOpen,
  MessagesSquare,
  File,
} from 'lucide-react';
import ConferenceNav from '../../../common/ConferenceNav';
import NewFooter from '../../../common/NewFooter';
import SEO from '../../../common/SEO';

const PlanScientificPage = () => {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const systems = [
    {
      icon: <File className='w-4 h-4 sm:w-5 sm:h-5' />,
      title: 'Article Management System',
      color: 'from-yellow-400 to-yellow-500',
    },
    {
      icon: <Database className='w-4 h-4 sm:w-5 sm:h-5' />,
      title: 'Scientific Content Management',
      color: 'from-teal-400 to-teal-500',
    },
    {
      icon: <Users className='w-4 h-4 sm:w-5 sm:h-5' />,
      title: 'Registration Management System',
      color: 'from-pink-400 to-pink-500',
    },
    {
      icon: <Calendar className='w-4 h-4 sm:w-5 sm:h-5' />,
      title: 'Scientific schedules & Agendas',
      color: 'from-cyan-400 to-cyan-500',
    },
    {
      icon: <BookOpen className='w-4 h-4 sm:w-5 sm:h-5' />,
      title: 'Accelerated Citation & Content Access',
      color: 'from-blue-400 to-blue-500',
    },
    {
      icon: <MessagesSquare className='w-4 h-4 sm:w-5 sm:h-5' />,
      title: 'Submission Management System',
      color: 'from-purple-400 to-purple-500',
    },
  ];

  return (
    <>
      <SEO 
        title="Scientific Research Paper Writing & Journal Publication Support"
        description="Plan and organize Scientific Research conferences, Research paper writing and publication, Review paper writing bhopal, and SCI paper writing bhopal with Assurance Education Group."
        keywords={[
          "Scientific Research",
          "Research paper writing and publication",
          "Review paper writing bhopal",
          "Paper Writing Bhopal",
          "Conference paper writing publication",
          "SCI paper writing bhopal"
        ]}
        canonicalPath="/plan-scientific-page"
      />
      <ConferenceNav />
      <div className='min-h-screen bg-gradient-to-br from-purple-100 via-pink-100 pt-28 pb-8 to-blue-100'>
        <div className='max-w-7xl mx-auto px-4  '>
          {isMobile ? (
            <div className='flex flex-col items-center'>
              <div className='text-center mb-8'>
                <h1 className='text-2xl font-bold mb-4'>
                  Plan <span className='text-red-600'>International</span>
                  <br />
                  <span className='text-red-800'>Scientific Conference</span>
                </h1>
                <p className='text-sm text-gray-600 px-4'>
                  Transform your institution into a hub of scientific
                  excellence. Connect brilliant minds, share groundbreaking
                  research, and foster global collaboration.
                </p>
              </div>

              <div className='flex flex-wrap justify-center gap-4 mb-6'>
                <button
                  onClick={() => navigate('/submit-proposal-form')}
                  className='px-6 py-2 bg-red-600 text-white text-sm rounded-lg hover:bg-red-700 transition-colors'
                >
                  Submit Proposal
                </button>
                <a
                  href={Browser}
                  download='Browser(2025) .pdf'
                  className='px-6 py-2 bg-white text-sm text-black rounded-lg shadow hover:bg-gray-50 transition-all'
                >
                  Download Brochure
                </a>
              </div>

              <div className='w-full max-w-md mx-auto'>
                <div className='bg-white rounded-2xl shadow-lg p-4 mb-4 text-center'>
                  <h3 className='text-lg font-semibold text-slate-800'>
                    Scientific Conference Management Systems
                  </h3>
                </div>

                <div className='grid grid-cols-2 gap-3'>
                  {systems.map((system, index) => (
                    <div
                      key={index}
                      className='bg-white rounded-xl shadow p-3 flex flex-col items-center hover:scale-[1.03] transition-transform duration-200'
                    >
                      <div
                        className={`w-8 h-8 rounded-full mb-2 flex items-center justify-center bg-gradient-to-r ${system.color} text-white`}
                      >
                        {system.icon}
                      </div>
                      <h4 className='text-xs font-semibold text-center text-slate-700 leading-tight'>
                        {system.title}
                      </h4>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <div className='flex flex-col lg:flex-row items-center lg:items-start justify-between gap-6 lg:gap-8 xl:gap-12 mt-12 lg:mt-20 w-full overflow-hidden lg:overflow-visible'>
              <div className='w-full lg:w-[46%] xl:w-[48%] space-y-6 lg:space-y-8'>
                <h1 className='text-3xl sm:text-4xl xl:text-5xl font-bold leading-tight text-slate-900'>
                  Plan{' '}
                  <span className='text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-red-800'>
                    International Scientific Conferences
                  </span>
                </h1>
                <p className='text-base sm:text-lg xl:text-xl text-gray-600 leading-relaxed'>
                  Transform your institution into a hub of scientific
                  excellence. Connect brilliant minds, share groundbreaking
                  research, and foster global collaboration.
                </p>
                <div className='flex flex-wrap gap-4 pt-4'>
                  {/* Submit Proposal Button */}
                  <button
                    className='px-6 py-2.5 sm:px-8 sm:py-3 bg-gradient-to-r from-red-600 to-red-700 text-white rounded-lg font-semibold hover:scale-105 transition-transform shadow-md hover:shadow-lg'
                    onClick={() => navigate('/submit-proposal-form')}
                  >
                    Submit Proposal
                  </button>

                  {/* Download Brochure Button */}
                  <a
                    href={Browser}
                    download='Browser(2025) .pdf'
                    className='px-6 py-2.5 sm:px-8 sm:py-3 bg-white text-gray-700 rounded-lg font-semibold shadow-md hover:shadow-lg transition-all hover:scale-105'
                  >
                    Download Brochure
                  </a>
                </div>
              </div>

              <div className='w-full lg:w-[48%] relative flex justify-center items-center mt-8 lg:mt-0'>
                <div
                  className='relative w-full max-w-[360px] sm:max-w-[420px] lg:max-w-[380px] xl:max-w-[460px] 2xl:max-w-[500px] scale-95 sm:scale-100 lg:scale-[0.9] xl:scale-95 2xl:scale-100 transition-all duration-300 origin-center'
                  style={{ aspectRatio: '1/1' }}
                >
                  <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-36 h-36 xl:w-44 xl:h-44 bg-white rounded-full shadow-xl flex items-center justify-center text-center p-4 z-10 border border-slate-100'>
                    <h3 className='font-bold text-sm xl:text-base text-slate-800 leading-snug'>
                      Scientific Conference Management Systems
                    </h3>
                  </div>

                  {systems.map((system, index) => {
                    const angle =
                      index * (360 / systems.length) * (Math.PI / 180);
                    const cosVal = (Math.cos(angle) * 34).toFixed(2);
                    const sinVal = (Math.sin(angle) * 34).toFixed(2);

                    return (
                      <div
                        key={index}
                        className='absolute transform -translate-x-1/2 -translate-y-1/2 transition-all duration-300 hover:scale-110 z-20'
                        style={{
                          left: `calc(50% + ${cosVal}%)`,
                          top: `calc(50% + ${sinVal}%)`,
                        }}
                      >
                        <div className='w-28 sm:w-32 bg-white rounded-xl shadow-lg p-2.5 sm:p-3 flex flex-col items-center text-center border border-slate-50'>
                          <div
                            className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full mb-1.5 sm:mb-2 flex items-center justify-center bg-gradient-to-r ${system.color} text-white shadow-sm`}
                          >
                            {system.icon}
                          </div>
                          <h4 className='text-[10px] sm:text-xs font-semibold leading-tight text-slate-700'>
                            {system.title}
                          </h4>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className='w-screen'>
        <NewFooter />
      </div>
    </>
  );
};

export default PlanScientificPage;
